<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import { isMobile, URL_INPUT_PREFIX } from "../../utils/utilities";
  import PriceLines from "../base/PriceLines.svelte";

  export let hasBorder;
  export let fullScreenMobile;
  export let translateChatAnswer;
  export let type;
  export let multiline = false;
  export let item = null;
  export let currency = "";

  let value = "";
  let lastType;
  let chatTextBox;

  $: if (type !== lastType) {
    value = "";
    lastType = type;
  }

  const dispatch = createEventDispatcher();

  function action() {
    dispatch("message", type === "price" ? (item?.val ?? "") : value);
    value = "";
    if (multiline && chatTextBox) {
      chatTextBox.style.height = "35px";
    }
  }

  function handleFocus() {
    if (type === "url" && value === "") {
      value = URL_INPUT_PREFIX;
    }
  }

  const handleKeyPress = () => {
    if (event.code == "Enter") {
      event.preventDefault();
    }
  };

  function autoResize() {
    if (chatTextBox) {
      chatTextBox.style.height = "35px";
      chatTextBox.style.height = chatTextBox.scrollHeight + "px";
    }
  }

  function handleTextareaKeydown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      action();
    }
  }
</script>

<div class="chatwith-chat-textbox" class:fullScreenMobile class:hasBorder class:multiline class:price-lines={type === "price"}>
  <div class="chatwith-chat-textbox-input">
    {#if multiline}
      <textarea
        placeholder={translateChatAnswer ?? "Type your message"}
        bind:value
        bind:this={chatTextBox}
        on:input={autoResize}
        on:keydown={handleTextareaKeydown}
        rows="1"
      />
    {:else if type == "date"}
      <input
        type="date"
        placeholder={translateChatAnswer ?? "Type your message"}
        bind:value
        on:keyup|stopPropagation={(e) => e.key === "Enter" && action()}
        bind:this={chatTextBox}
        on:keypress={handleKeyPress}
      />
    {:else if type === "price" && item}
      {#key item}
        <PriceLines {item} {currency} />
      {/key}
    {:else if type === "number"}
      <input
        type="number"
        placeholder={translateChatAnswer ?? "Type your message"}
        bind:value
        on:keyup|stopPropagation={(e) => e.key === "Enter" && action()}
        bind:this={chatTextBox}
        on:keypress={handleKeyPress}
        on:focus={handleFocus}
      />
    {:else}
      <input
        type="text"
        placeholder={translateChatAnswer ?? "Type your message"}
        bind:value
        on:keyup|stopPropagation={(e) => e.key === "Enter" && action()}
        bind:this={chatTextBox}
        on:keypress={handleKeyPress}
        on:focus={handleFocus}
      />
    {/if}
  </div>
  <div class="chatwith-chat-textbox-button">
    <button on:click={() => action()}>
      <svg width="24px" height="24px" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg"
        ><defs
          ><style>
            .cls-1 {
              fill: none;
            }
          </style></defs
        >
        <path
          fill="#fff"
          d="M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
        />
      </svg>
    </button>
  </div>
</div>
